module.exports = __webpack_public_path__ + "static/smi3Mini-c6d45f82163f5b2e4897ab3891530aa8.png";